import {Component, OnInit, ChangeDetectionStrategy, Input, Inject} from '@angular/core';
import {HeaderInfo} from "@ispm/test/interfaces/header-info.interface";
import {get, has} from "lodash";
import {TEST_ID_PATH} from "@ispm/test/components/test-bar/test-bar.component";
import * as _ from "lodash";
import {IDiagnosticOrder, IRevision} from "@ispm/test/interfaces/diagnostic-order.interface";
import {TestConfiguration} from "@ispm/test/interfaces/test-configuration.interface";
import { TestService } from '../../services/test.service';

export interface InfoOrigin {
  patientAnalyses: { current: IDiagnosticOrder };
}

@Component({
  selector: 'ispm-header-info',
  templateUrl: './header-info.component.html',
  styleUrls: ['./header-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderInfoComponent implements OnInit {
  @Input() infoOrigin: InfoOrigin;
  public flattenHeaders = false;
  public headerInfo: HeaderInfo[] = [];
  showInfo: boolean = false;
  public testConfiguration: TestConfiguration;

  constructor(private testService: TestService) {    
    this.testConfiguration = this.testService.testConfiguration;
  }


  ngOnInit() {
    this.buildInfo();
  }

  trackByIndex(index: number): number {
    return index;
  }

  private buildInfo(): void {
    if (this.testService.testConfiguration && this.testService.testConfiguration.flattenHeaders) {
      this.flattenHeaders = this.testService.testConfiguration.flattenHeaders;
    }

    if (this.testService.testConfiguration && this.testService.testConfiguration.headerInfoFields) {
      for (const info of this.testService.testConfiguration.headerInfoFields) {
        let cssClassPresent = false, cssClass;
        let infoAsObject: boolean = false;
        if (typeof info === 'object') {
          infoAsObject = true;
        }

        if (infoAsObject) {
          const infoObject = info as Object;
          if (has(infoObject, 'cssClass')) {
            cssClassPresent = true;
            cssClass = get(infoObject, 'cssClass');
          }
          let headerValue = {};
          if (has(infoObject, 'pathToValue')) {
            headerValue = this.getPropertyValueByPath(this.infoOrigin, get(infoObject, 'pathToValue'));
          } else {
            headerValue = get(infoObject, 'value');
          }

          const row = {
            name: get(infoObject, 'label'),
            values: [],
            cssClassAvailable: cssClassPresent,
            cssClass
          };
          if (Array.isArray(headerValue)) {
            row.values.concat(headerValue);
          } else {
            row.values.push(headerValue);
          }
          this.headerInfo.push(row);
        } else {
          const headerValue = this.getPropertyValueByPath(this.infoOrigin, info);
          const row = {name: info, values: [], cssClassAvailable: false};
          if (Array.isArray(headerValue)) {
            row.values.concat(headerValue);
          } else {
            row.values.push(headerValue);
          }
          this.headerInfo.push(row);
        }
      }
    } else {
      const name = TEST_ID_PATH;
      this.headerInfo.push({
        name: name,
        values: [_.get(this.infoOrigin, name)],
        cssClassAvailable: false
      });
    }
  }

  private getPropertyValueByPath(obj: any, propName: string): any {
    const path = propName.split('.');
    let current = obj;
    while (path.length > 0) {
      let currentPath = path.shift();
      if (currentPath.indexOf('[') >= 0) {
        const indexMatch = /\[([\d*]+)]/g.exec(currentPath);
        const index = parseInt(indexMatch[1]);
        currentPath = currentPath.replace(indexMatch[0], '');
        if (!isNaN(index)) {
          current = current[currentPath][index];
        } else {
          const temp = [];
          for (const sub of current[currentPath]) {
            temp.push(this.getPropertyValueByPath(sub, path.join('.')));
          }
          return temp;
        }
      } else {
        current = current[currentPath];
      }
    }
    return current;
  }
}
